export default {
  "name": "NCTable",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCTable",
  "label": "表格",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "tableType": {
        "title": "表格类型",
        "description": "表格类型",
        "enumNames": [
          "不可编辑表格",
          "可编辑表格"
        ],
        "type": "enum",
        "enum": [
          "simpleTable",
          "editTable"
        ],
        "default": "simpleTable"
      },
      "showIndex": {
        "title": "显示序号",
        "description": "显示序号",
        "type": "boolean",
        "default": true
      },
      "showCheck": {
        "title": "显示复选框",
        "description": "显示复选框",
        "type": "boolean",
        "default": true
      },
      "height": {
        "title": "是否滚动加载",
        "description": "是否滚动加载",
        "type": "number"
      },
      "lazyload": {
        "title": "是否滚动加载",
        "description": "是否滚动加载",
        "type": "boolean",
        "default": true
      },
      "adaptionHeight": {
        "title": "是否自适应高度",
        "description": "是否自适应高度",
        "type": "boolean",
        "default": true
      },
      "multipleRowCell": {
        "title": "是否显示多行",
        "description": "是否显示多行",
        "type": "boolean"
      },
      "rowClassName": {
        "title": "行样式",
        "description": "行样式",
        "type": "string"
      },
      "crossPageSelect": {
        "title": "跨页多选 ---------------------simpletable独有",
        "description": "跨页多选",
        "type": "boolean"
      },
      "cancelCustomRightMenu": {
        "title": "是否取消右键菜单",
        "description": "是否取消右键菜单",
        "type": "boolean"
      },
      "addBlankCol": {
        "title": "是否增加空白列",
        "description": "是否增加空白列",
        "type": "boolean"
      },
      "showWidthAndHeightConfig": {
        "title": "显示宽高配置",
        "description": "显示宽高配置",
        "type": "boolean"
      },
      "bodyExpandAllInRow": {
        "title": "多行展示是否显示全部内容",
        "description": "多行展示是否显示全部内容",
        "type": "boolean"
      },
      "inModal": {
        "title": "是否在弹窗内",
        "description": "是否在弹窗内",
        "type": "boolean",
        "default": false
      },
      "disableRowClickSelect": {
        "title": "行点击是否勾选",
        "description": "行点击是否勾选",
        "type": "boolean"
      },
      "isAddRow": {
        "title": "最后一行录入数据自动增行",
        "description": "最后一行录入数据自动增行",
        "type": "boolean",
        "default": false
      },
      "hideRightMenu": {
        "title": "隐藏右键菜单",
        "description": "隐藏右键菜单",
        "type": "boolean"
      },
      "focusIndex": {
        "title": "活动索引",
        "description": "活动索引",
        "type": "number"
      },
      "isSort": {
        "title": "是否需要排序",
        "description": "是否需要排序",
        "type": "boolean"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}